import { useNavigationResolver } from './useNavigationResolver';

export const useController = () => {
  const { loading } = useNavigationResolver();

  return {
    loading,
  };
};
